import { useWordProcessorStore } from "~/components/Base/WordProcessor/useWordProcessorStore";

// Follow live editor changes as well as saved revisions, including undo/redo.
export const useDocumentTeacherCommentCorrections = (documentId: string) => {
  const { revision } = storeToRefs(useSubmittedDocumentStore(documentId));
  const wordProcessorStore = useWordProcessorStore(documentId);
  const { editorRef } = storeToRefs(wordProcessorStore);
  const contentVersion = ref(0);
  const corrections = computed(() => {
    contentVersion.value;
    const quill = wordProcessorStore.getQuillInstance();
    return useTeacherCommentCorrections(
      quill?.getContents?.()?.ops ?? revision.value?.studentSubmissionOps
    );
  });

  const onTextChange = () => { contentVersion.value++; };
  let observedQuill: ReturnType<typeof wordProcessorStore.getQuillInstance>;
  const observeEditor = () => {
    const quill = wordProcessorStore.getQuillInstance();
    if (quill === observedQuill) return;
    observedQuill?.off("text-change", onTextChange);
    observedQuill = quill;
    observedQuill?.on("text-change", onTextChange);
    contentVersion.value++;
  };

  watch(editorRef, observeEditor, { immediate: true, flush: "post" });
  onMounted(observeEditor);
  onUnmounted(() => observedQuill?.off("text-change", onTextChange));
  return corrections;
};
